import { render, staticRenderFns } from "./im.vue?vue&type=template&id=94a88014"
import script from "./im.vue?vue&type=script&lang=js"
export * from "./im.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports